import { React } from "react";
import { gql, useQuery } from "@apollo/client";
import { RichText } from "@graphcms/rich-text-react-renderer";
// import { useMediaQuery } from "react-responsive";

const Article = (props) => {
  const MyQuery = gql`
    query MyQuery($slug: String!) {
      marketing(where: { url: $slug }) {
        article {
          raw
          html
          markdown
          text
        }
      }
    }
  `;
  // const isBigScreen = useMediaQuery({ query: "(min-width: 700px)" });
  // const isTabletOrMobile = useMediaQuery({ query: "(max-width: 600px)" });
  
    let el = document.getElementsByClassName("cta");
    let url = "https://wa.me/6281399000000";
    for (let i = 0; i < el.length; i++) {
      el[i].addEventListener("click", function() {
        window.open(url, "_blank").focus();
      });
    }
  
  const { loading, error, data } = useQuery(MyQuery, {
    variables: { slug: props.data },
    
  });
  if (loading) return "Loading....";
  if (error) return `Error! ${error.message}`;
  const content = data.marketing.article.raw.children;

  return (
    <div className="container mx-auto px-4">
      <RichText
        content={content}
        renderers={{
          h1: ({ children }) => (
            <h1 className="font-bold text-3xl my-10">{children}</h1>
          ),
          h2: ({ children }) => <h2 className="p-1">{children}</h2>,
          h4: ({ children }) => <h4 className="p-1">{children}</h4>,
          p: ({ children }) => <p className="my-2 p-1">{children}</p>,
          ul: ({ children }) => (
            <ul className="list-disc px-12">{children}</ul>
          ),
          cta: ({ children }) => (
            <div className="cta">
              {(
                <a href="https://wa.me/6281399000000">
                  <img src="https://media.graphassets.com/vjvKlHSMTcCTrbnC02Av" alt="" />
                </a>
              )}
            </div>
            // <div>
            //   {isBigScreen && (
            //     <a href="https://wa.me/6281399000000">
            //       <img
            //         src="https://media.graphassets.com/IQsw9BYuQvyellf5hxoY"
            //         alt=""
            //       />
            //     </a>
            //   )}
            //   {isTabletOrMobile && (
            //     <a href="https://wa.me/6281399000000">
            //       <img
            //         src="https://media.graphcms.com/oHIhkbaUTaaS8I9mZWdh"
            //         alt=""
            //         className=""
            //       />
            //     </a>
            //   )}
            // </div>
          ),
        }}
      />
    </div>
  );
};

export default Article;
